import type {
  LoginRequest,
  LoginResponse,
  MfaSetupResponse,
  MfaVerifyRequest,
  PublicTenantDto,
} from '@an-crm/shared';
import { api } from '@/lib/api/client';

export interface TokenResponse {
  status?: 'ok';
  accessToken: string;
  expiresIn: number;
}

export const authApi = {
  login: (body: LoginRequest) => api<LoginResponse>('/auth/login', { method: 'POST', body, auth: false }),
  mfaVerify: (body: MfaVerifyRequest) =>
    api<TokenResponse>('/auth/mfa/verify', { method: 'POST', body, auth: false }),
  mfaSetup: (challengeToken: string) =>
    api<MfaSetupResponse>('/auth/mfa/setup', { method: 'POST', body: { challengeToken }, auth: false }),
  logout: () => api<void>('/auth/logout', { method: 'POST' }),
  publicTenant: (slug: string, signal?: AbortSignal) =>
    api<PublicTenantDto>(`/public/tenants/${encodeURIComponent(slug)}`, { auth: false, signal }),
};
